import { useState } from "react";
import { Languages } from "lucide-react";
import { toast } from "sonner";

export function TranslationDraftButton({ onTranslate, disabled = false, className = "" }) {
  const [isTranslating, setIsTranslating] = useState(false);

  const handleClick = async () => {
    setIsTranslating(true);
    try {
      const result = await onTranslate();
      if (result.missing_languages?.length) {
        toast.warning(`Taslak oluşturuldu; ${result.missing_languages.length} dilde eksik alan kaldı.`);
      } else {
        toast.success("Eksik çeviriler taslak olarak dolduruldu.");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Çeviri taslağı oluşturulamadı.");
    } finally {
      setIsTranslating(false);
    }
  };

  return (
    <button
      type="button"
      disabled={disabled || isTranslating}
      onClick={handleClick}
      className={`inline-flex items-center justify-center gap-2 rounded-xl border border-brand/30 bg-brand/5 px-4 py-3 text-sm font-semibold text-brand transition hover:bg-brand/10 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      <Languages className={`h-4 w-4 ${isTranslating ? "animate-pulse" : ""}`} />
      {isTranslating ? "Çevriliyor…" : "Eksik dilleri Gemini ile çevir"}
    </button>
  );
}
